import { fromJS } from 'immutable';

const KEY = 'searchResult';

export function request(state) {
    return state.setIn([ KEY, 'state' ], 'IN_PROGRESS')
                .setIn([ KEY, 'items' ], fromJS([]));
}

export function error(state, { errors }) {
    return state.setIn([ KEY, 'state' ], 'ERROR')
        .setIn([ 'errors' ], errors );
}

export function finish(state, { events }) {
    return state.setIn([ KEY, 'state' ], 'FINISH')
        .setIn([ KEY, 'items' ], fromJS(events));
}
